// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function ErrorPage(props) {
  var error = props.error;
  return React.createElement(React.Fragment, undefined, React.createElement("h2", {
                  className: "text-lg leading-6 font-medium text-gray-900 flex-grow"
                }, "Error:"), React.createElement("p", undefined, "Path: " + error.path + ""), React.createElement("p", undefined, "Message: " + error.message + ""), React.createElement("p", undefined, "Value: " + JSON.stringify(error.value, null, 2) + ""));
}

var make = ErrorPage;

export {
  make ,
}
/* react Not a pure module */
